import React from 'react';

const PendingChanges = ({ pages, splits, onUndo, canUndo }) => {
  const changes = [];

  pages.forEach((page, idx) => {
    if (page.deleted) {
      changes.push({
        type: 'delete',
        description: `Delete page ${idx + 1}`,
        icon: '🗑',
      });
    }
    if (page.rotation !== 0) {
      changes.push({
        type: 'rotate',
        description: `Rotate page ${idx + 1} by ${page.rotation}°`,
        icon: '↻',
      });
    }
    if (page.originalIndex !== idx) {
      changes.push({
        type: 'reorder',
        description: `Move page ${page.originalIndex + 1} to position ${idx + 1}`,
        icon: '↕',
      });
    }
  });

  Array.from(splits).forEach((beforePageIndex) => {
    changes.push({
      type: 'split',
      description: `Split before page ${beforePageIndex}`,
      icon: '✂',
    });
  });

  if (changes.length === 0) {
    return (
      <div className="ds-pending-changes">
        <div className="ds-pending-changes-header">Pending Changes</div>
        <div className="ds-pending-changes-empty">No pending changes</div>
      </div>
    );
  }

  return (
    <div className="ds-pending-changes">
      <div className="ds-pending-changes-header">
        Pending Changes ({changes.length})
      </div>
      <div className="ds-pending-changes-list">
        {changes.map((change, idx) => (
          <div key={idx} className="ds-pending-change-item">
            <span className="ds-pending-change-icon">{change.icon}</span>
            <span className="ds-pending-change-description">{change.description}</span>
          </div>
        ))}
      </div>
      {canUndo && (
        <button className="ds-pending-changes-undo" onClick={onUndo}>
          ⟲ Undo Last Change
        </button>
      )}
    </div>
  );
};

export default PendingChanges;
